// extracted by mini-css-extract-plugin
export default {"mainDiv":"Author_mainDiv__zZCCe","subDiv1":"Author_subDiv1__ySuzv","subDiv2":"Author_subDiv2__Ip6fH"};